import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchRecordMessages = (ftrId) =>
  apiActionCreator({
    'endpoint': `/record/messages?idFTR=${ftrId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_RECORD_MESSAGES_LIST,
      ActionTypes.FETCHED_RECORD_MESSAGES_LIST,
      [ActionTypes.FETCHED_RECORD_MESSAGES_LIST_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addRecordMessage = (data = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/record/message/add',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_RECORD_MESSAGES_LIST,
        [
          () => {
            dispatch(fetchRecordMessages(data.idFTR));
            return {
              'type': ActionTypes.ADDED_RECORD_MESSAGES_LIST,
              'payload': data,
            };
          },
        ],
        [ActionTypes.ADDED_RECORD_MESSAGES_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};
